import React, { useState } from 'react';
import { Alert, Typography } from '@mui/material';
import { DataGrid, GridColDef, deDE } from '@mui/x-data-grid';
import { Check, Close } from '@mui/icons-material';
import { LanguageSectionWrapper } from './LanguageSectionWrapper';
import { LoadingSpinner } from '../../core/LoadingSpinner';
import { useGetLanguageSections } from '../../hooks/reactQuerys/LanguageseSectionQueries';

const columns: GridColDef[] = [
  { field: 'idLanguageSection', headerName: 'Nr.', width: 90 },
  {
    field: 'isPublic',
    headerName: 'Öffentlich',
    width: 150,
    renderCell: params =>
      Boolean(params.row.isPublic) ? <Check /> : <Close />,
  },
  { field: 'LanguageSection', headerName: 'Bezeichnung', flex: 1 },
];

export const LanguageSectionOverview = () => {
  const { languageSections, isLoadingLanguageSections } =
    useGetLanguageSections();
  const [idLanguageSection, setIdLanguageSection] = useState<number | null>(
    null
  );

  if (isLoadingLanguageSections) {
    return <LoadingSpinner />;
  }

  if (!languageSections) {
    return <Alert severity='error'>Fehler!</Alert>;
  }

  return (
    <>
      {idLanguageSection !== null && (
        <LanguageSectionWrapper
          idLanguageSection={idLanguageSection}
          setIdLanguageSection={setIdLanguageSection}
        />
      )}

      <Typography variant='h5' sx={{ mt: 5 }}>
        Sprachpakete/-sektionen
      </Typography>

      <DataGrid
        localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
        rows={languageSections}
        columns={columns}
        getRowId={row => row.idLanguageSection}
        onRowClick={params => setIdLanguageSection(Number(params.id))}
        autoHeight
      />
    </>
  );
};
